import { ChangeDetectionStrategy, Component, input, inject } from "@angular/core";
import { BehaviorSubject, map } from "rxjs";
import { ClientDataService } from "src/app/services/customer-supplied-data/client-data.service";
import { StartPayoutAgeService } from "src/app/services/start-payout-age.service";
import { LetDirective } from "../../../shared/directives/let.directive";
import { SimulationParamsPanelComponent } from "./simulation-params-panel/simulation-params-panel.component";
import { AsyncPipe } from "@angular/common";
import { FmsPipe } from "../../../shared/pipes/fms.pipe";
import { ButtonModule } from "@storeblocks/button-ng";

@Component({
  selector: "app-simulation-params-activator",
  templateUrl: "./simulation-params-activator.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LetDirective, SimulationParamsPanelComponent, AsyncPipe, FmsPipe, ButtonModule],
})
export class SimulationParamsActivatorComponent {
  private readonly clientDataService = inject(ClientDataService);

  readonly simulateDifferentTimes = input(false);

  readonly startPayoutAgeService = inject(StartPayoutAgeService);
  public readonly startPayoutAge$;
  public readonly simulationParametersByEngagementEnable$;
  public readonly open$ = new BehaviorSubject(false);

  constructor() {
    const startPayoutAgeService = this.startPayoutAgeService;

    this.startPayoutAge$ = startPayoutAgeService.getStartPayoutAge();
    this.simulationParametersByEngagementEnable$ = this.clientDataService.simulationParametersByEngagementEnable$.pipe(
      map(({ switches: { userActivated } }) => userActivated),
    );
  }

  public openPanel(): void {
    this.open$.next(true);
  }

  public closePanel(): void {
    this.open$.next(false);
  }

  public togglePanel(): void {
    this.open$.next(!this.open$.getValue());
  }
}
